module.exports = __webpack_public_path__ + "fonts/b6b9c625cd327ca7ddef82aa3d1ed3d4.svg";